// ─────────────────────────────────────────────
//  CENTRAL CONFIG — edit this file to swap clients
// ─────────────────────────────────────────────
export const siteConfig = {
  // ── Chat Widget ──────────────────────────────────────────────────────────
  // Paste the contractor's chat widget embed details here.
  // src:   the script src URL from their chat platform embed code
  // attrs: any data-* attributes the script tag needs (key → value)
  // Leave src as "" to disable the widget entirely.
  //
  // GoHighLevel / LeadConnector example:
  //   src: "https://widgets.leadconnectorhq.com/loader.js",
  //   attrs: {
  //     "data-resources-url": "https://widgets.leadconnectorhq.com/chat-widget/loader.js",
  //     "data-widget-id": "PASTE_WIDGET_ID_HERE",
  //   },
  chatWidget: {
    src: "https://widgets.leadconnectorhq.com/loader.js",
    attrs: {
      "data-resources-url": "https://widgets.leadconnectorhq.com/chat-widget/loader.js",
      "data-widget-id": "6a825432e5c16f9849c1f069",
    },
  },

  businessName: "Construct With Us",
  // Set to "/assets/logo.png" once a real logo file is placed in public/assets/
  // Leave as "" to use the auto-generated SVG mark instead
  logo: "",
  // Drop any .ico, .png, or .svg file in public/assets/ and set the path here.
  // Leave as "" to keep the default blank favicon.
  favicon: "",
  // Brand accent icon used throughout the site (eyebrow badges, CTA buttons, section labels).
  // Must match a key in src/utils/icons.js. Common choices: "HardHat", "Wrench", "Hammer",
  // "Home", "Leaf", "Droplets", "Zap", "Flame", "Building2", "Shovel"
  brandIcon: "HardHat",
  phone: "(877) 318-3460",
  phoneHref: "tel:+18773183460",
  email: "info@constructwithus.com",
  city: "Dallas",
  state: "TX",

  serviceAreas: [
    "Dallas",
    "Plano",
    "Frisco",
    "McKinney",
    "Garland",
    "Richardson",
    "Allen",
    "Mesquite",
  ],

  colors: {
    primary:     "#E07B00",
    primaryDark: "#B86200",
    dark:        "#111418",
    light:       "#F6F5F2",
    accent:      "#FFA726",
  },

  hero: {
    eyebrow: "Residential • Commercial • Renovation",
    // The headline is split into two parts — the highlight renders in the brand primary color
    headline: "Built Right, Built to",
    headlineHighlight: "Last.",
    subheadline:
      "Full-service construction for homeowners and businesses across the Dallas–Fort Worth area. From new builds and additions to full remodels — we deliver on time, on budget, and built to code.",
    image:
      "https://images.unsplash.com/photo-1541888946425-d81bb19240f5?w=1920&h=1080&fit=crop",
    // Primary CTA → contact/quote page
    ctaPrimaryLabel: "Get My Free Quote",
    ctaPrimaryHref: "/contact",
    // Secondary CTA → gallery or any path/url
    ctaSecondaryLabel: "View Our Work",
    ctaSecondaryHref: "/gallery",
  },

  about: {
    headline: "Dallas-Fort Worth's Trusted General Contractor",
    // Homepage about section — split headline with a colored middle phrase
    headlineMain:      "Construction You Can",
    headlineHighlight: "Trust,",
    headlineEnd:       "Results You'll Love",
    body: "At Construct With Us, we believe every project — whether it's a kitchen remodel or a ground-up commercial build — deserves the same level of craftsmanship, communication, and care. We're a locally owned general contracting firm serving the greater Dallas area with a crew that takes pride in doing the job right the first time.",
    body2: "From pulling permits to final walkthrough, we manage every detail so you don't have to. No surprises, no shortcuts — just solid construction delivered on schedule.",
    image:
      "https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=1200&h=900&fit=crop",
    founded: "2011",
    projectsCompleted: "750+",
    yearsExperience: "13+",
    overlayCard: {
      icon: "ShieldCheck",
      title: "Licensed, Bonded & Insured",
      sub: "Fully credentialed in Texas. Every project covered, no exceptions.",
    },
    values: [
      { icon: "Award",       title: "Quality Craftsmanship",   body: "We use proven materials and skilled tradespeople on every job — residential or commercial." },
      { icon: "Users",       title: "Clear Communication",     body: "You'll always know where your project stands. We return calls, send updates, and keep you in the loop." },
      { icon: "ShieldCheck", title: "Licensed & Insured",      body: "Fully licensed by the State of Texas, bonded, and insured so you're protected from day one." },
      { icon: "ThumbsUp",    title: "On Time, On Budget",      body: "We set realistic timelines, stick to them, and flag any changes before they become surprises." },
    ],
  },

  services: [
    {
      name: "New Home Construction",
      slug: "new-home-construction",
      icon: "Home",
      shortDescription:
        "Custom new home builds delivered on schedule and built to last — from foundation to final walkthrough.",
      description:
        "Building a new home is one of the biggest decisions you'll ever make. We guide you through every phase — design coordination, permitting, site prep, framing, mechanical rough-ins, finishes, and inspection — so you can move in with confidence. We build custom homes across the Dallas–Fort Worth area that reflect your vision and stand the test of time.",
      benefits: [
        "Full project management from break-ground to move-in",
        "Transparent budget tracking and change-order process",
        "Coordination of all trades — framing, electrical, plumbing, HVAC",
        "Built to Texas building code with all permits handled",
      ],
      commonProjects: [
        "Single-family custom homes",
        "Spec homes and investment builds",
        "Luxury estate construction",
        "Accessory dwelling units (ADUs)",
      ],
      image:
        "https://images.unsplash.com/photo-1570129477492-45c003edd2be?w=900&h=600&fit=crop",
    },
    {
      name: "Commercial Construction",
      slug: "commercial-construction",
      icon: "Building2",
      shortDescription:
        "Commercial builds and tenant improvements delivered on time with minimal disruption to your business.",
      description:
        "We partner with business owners, property managers, and developers to deliver commercial construction projects that meet code, stay on schedule, and hold up under real-world use. From ground-up retail and office builds to warehouse fit-outs and restaurant renovations, our commercial division handles projects of all sizes.",
      benefits: [
        "Experienced with commercial permits and inspections",
        "Phased construction to minimize business downtime",
        "ADA compliance built into every commercial project",
        "Dedicated project superintendent on every job",
      ],
      commonProjects: [
        "Retail and restaurant build-outs",
        "Office and medical tenant improvements",
        "Warehouse and industrial construction",
        "Multi-unit residential developments",
      ],
      image:
        "https://images.unsplash.com/photo-1486325212027-8081e485255e?w=900&h=600&fit=crop",
    },
    {
      name: "Home Additions",
      slug: "home-additions",
      icon: "PlusSquare",
      shortDescription:
        "Seamlessly expand your living space with a professionally designed and built home addition.",
      description:
        "Need more space but love your neighborhood? A home addition lets you stay put and grow. We design and build additions that match your home's existing structure, materials, and style so the new space feels like it was always there. From master suite additions to second-story expansions, we do it right.",
      benefits: [
        "Matches existing home materials and architecture",
        "Increases square footage and home value",
        "All structural engineering and permits handled",
        "Minimizes disruption to your daily routine",
      ],
      commonProjects: [
        "Master bedroom and bathroom suites",
        "Second-story additions",
        "In-law suites and guest quarters",
        "Garage conversions and sunroom additions",
      ],
      image:
        "https://images.unsplash.com/photo-1503387762-592deb58ef4e?w=900&h=600&fit=crop",
    },
    {
      name: "Kitchen & Bath Remodeling",
      slug: "kitchen-bath-remodeling",
      icon: "Hammer",
      shortDescription:
        "Transform your kitchen or bathroom with expert remodeling that combines function, beauty, and lasting value.",
      description:
        "Kitchens and bathrooms sell homes — and make everyday life better. We handle every phase of your remodel: demolition, structural changes, plumbing and electrical rough-ins, tile, cabinetry, countertops, and fixtures. The result is a space that looks and performs exactly the way you want it to.",
      benefits: [
        "High return on investment at resale",
        "All trades coordinated under one contract",
        "Design assistance for layouts, materials, and finishes",
        "Detailed timeline so you know when your kitchen is back",
      ],
      commonProjects: [
        "Full kitchen gut and remodel",
        "Primary bathroom renovations",
        "Jack-and-Jill and hall bath updates",
        "Laundry room and mudroom remodels",
      ],
      image:
        "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=900&h=600&fit=crop",
    },
    {
      name: "Roofing & Structural Repairs",
      slug: "roofing-structural-repairs",
      icon: "HardHat",
      shortDescription:
        "Roof replacements, storm damage repairs, and structural fixes done properly — no patchwork solutions.",
      description:
        "When your roof or structure is compromised, you need a contractor who does it right — not one who covers up the problem. We assess the full scope of damage, provide a clear written estimate, handle insurance documentation when applicable, and complete repairs or full replacements to manufacturer and code specifications.",
      benefits: [
        "Full roof replacements and partial repairs",
        "Insurance claim documentation and support",
        "Storm damage assessment and remediation",
        "Structural beam, floor joist, and foundation repair",
      ],
      commonProjects: [
        "Full shingle and metal roof replacements",
        "Hail and wind damage repair",
        "Flat roof and TPO commercial systems",
        "Subfloor and structural framing repair",
      ],
      image:
        "https://images.unsplash.com/photo-1635424824800-692767998d07?q=80&w=1171&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    },
    {
      name: "Concrete & Foundation Work",
      slug: "concrete-foundation",
      icon: "Container",
      shortDescription:
        "Driveways, slabs, flatwork, and foundation repair — built level, built strong, built to last.",
      description:
        "Concrete is the backbone of most construction projects. Whether we're pouring a new driveway, a structural slab, a garage floor, or repairing a settling foundation, we take the base work seriously. Properly prepared, properly reinforced, and properly cured — every time.",
      benefits: [
        "Properly graded and reinforced with rebar or fiber mesh",
        "Expansion joints placed to prevent cracking",
        "Foundation pier and leveling systems available",
        "Stamped and decorative concrete options",
      ],
      commonProjects: [
        "Residential driveways and walkways",
        "Garage slabs and shop floors",
        "Foundation crack repair and pier installation",
        "Retaining walls and concrete flatwork",
      ],
      image:
        "https://images.unsplash.com/photo-1685464197644-41d9b07e1e73?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTJ8fENvbmNyZXRlJTIwJTI2JTIwRm91bmRhdGlvbnxlbnwwfHwwfHx8MA%3D%3D",
    },
  ],

  gallery: [
    "https://images.unsplash.com/photo-1541888946425-d81bb19240f5?w=800&h=600&fit=crop",
    "https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=800&h=600&fit=crop",
    "https://images.unsplash.com/photo-1570129477492-45c003edd2be?w=800&h=600&fit=crop",
    "https://images.unsplash.com/photo-1486325212027-8081e485255e?w=800&h=600&fit=crop",
    "https://images.unsplash.com/photo-1503387762-592deb58ef4e?w=800&h=600&fit=crop",
    "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=800&h=600&fit=crop",
    "https://images.unsplash.com/photo-1581094794329-c8112a89af12?w=800&h=600&fit=crop",
    "https://images.unsplash.com/photo-1590736969955-71cc94901144?w=800&h=600&fit=crop",
  ],

  reviews: [
    {
      name: "Brian H.",
      location: "Plano, TX",
      rating: 5,
      text: "Construct With Us built our home addition — a full master suite off the back of the house. The crew was professional, the timeline was accurate, and the finished product looks like it was always part of the original house. Couldn't be happier.",
    },
    {
      name: "Monica S.",
      location: "Frisco, TX",
      rating: 5,
      text: "We hired them for a complete kitchen gut-and-remodel. They coordinated every trade, kept us updated daily, and finished within the promised window. The quality of the work is outstanding.",
    },
    {
      name: "James T.",
      location: "Dallas, TX",
      rating: 5,
      text: "Used them for a commercial tenant improvement on our office space. They worked nights and weekends to minimize disruption to our business and hit every milestone. I'll be calling them again for our next location.",
    },
    {
      name: "Angela R.",
      location: "McKinney, TX",
      rating: 5,
      text: "After the hailstorm last spring, we had significant roof damage. Construct With Us handled everything from the insurance adjuster visit to the final inspection. Stress-free process and great result.",
    },
    {
      name: "Derek W.",
      location: "Garland, TX",
      rating: 5,
      text: "They replaced our driveway, added a side concrete pad, and repaired the garage slab — all in one mobilization. Clean work, fair price, and the crew left the site tidy every evening.",
    },
    {
      name: "Priya K.",
      location: "Richardson, TX",
      rating: 5,
      text: "Our bathroom remodel was handled beautifully. They stuck to the schedule, the tile work is perfect, and the project manager was always reachable. Highly recommend for any home improvement project.",
    },
  ],

  faqs: [
    {
      q: "Do you handle all the permits?",
      a: "Yes. We pull all required permits through the relevant city or county, schedule inspections, and make sure every phase of the project is code-compliant. You don't have to navigate the permitting process — that's our job.",
    },
    {
      q: "Do you offer free estimates?",
      a: "Yes — all estimates are completely free. We'll meet with you on-site, review the scope of work, and provide a detailed written quote with no pressure and no obligation.",
    },
    {
      q: "Are you licensed and insured in Texas?",
      a: "Absolutely. We hold all required Texas contractor licenses, carry general liability insurance, and maintain workers' compensation coverage on all job sites. We're happy to provide documentation before any project begins.",
    },
    {
      q: "What areas of Dallas–Fort Worth do you serve?",
      a: `We serve the greater Dallas area including ${["Dallas", "Plano", "Frisco", "McKinney", "Garland", "Richardson", "Allen", "Mesquite"].join(", ")} and surrounding communities. Not sure if we cover your area? Give us a call.`,
    },
    {
      q: "How long will my project take?",
      a: "Timeline depends entirely on scope. A kitchen remodel typically runs 4–8 weeks. A home addition is usually 3–5 months. A new custom home is 9–14 months. We provide a detailed schedule at the start of every project and keep you updated throughout.",
    },
    {
      q: "Do you work with insurance companies on storm damage claims?",
      a: "Yes. We work directly with homeowners and their insurance adjusters to document damage, provide estimates that align with the claim, and complete repairs to code. We've helped many DFW homeowners navigate the claims process smoothly.",
    },
  ],

  trustBar: [
    { icon: "MapPin",      label: "Dallas–Fort Worth" },
    { icon: "Users",       label: "Family Owned" },
    { icon: "Clock",       label: "13+ Years Experience" },
    { icon: "ShieldCheck", label: "Fully Insured" },
    { icon: "BadgeCheck",  label: "Texas Licensed" },
  ],

  cta: {
    headline: "Ready to Start Your Project?",
    sub: "Get a free on-site estimate — no pressure, no obligation.",
    buttonLabel: "Get a Free Quote",
    image:
      "https://images.unsplash.com/photo-1541888946425-d81bb19240f5?w=1920&h=700&fit=crop",
  },

  googleReviewLink: "#",

  // ─── Before & After Slider ───────────────────────────────────────────────
  // Drop in two photo URLs to enable the Before/After slider on the homepage.
  // Leave `before` or `after` as "" to hide the section entirely.
  beforeAfter: {
    before:
      "https://images.unsplash.com/photo-1503387762-592deb58ef4e?w=1200&h=700&fit=crop",
    after:
      "https://images.unsplash.com/photo-1570129477492-45c003edd2be?w=1200&h=700&fit=crop",
    heading: "Before & After",
    sub:
      "See the difference our team makes — from rough conditions to a finished result. Drag the slider to compare.",
  },

  // ─── Blog ────────────────────────────────────────────────────────────────
  // Each post: slug (URL key), title, excerpt, content blocks.
  // Block types: { type: "p", text: "..." } | { type: "h2", text: "..." } | { type: "ul", items: [...] }
  // Add, remove, or reorder posts freely. The grid and detail pages adapt automatically.
  blog: {
    eyebrow: "Construction Insights",
    heading: "From the Blog",
    sub: "Project tips, industry knowledge, and home improvement guides from the Construct With Us team.",
    posts: [
      {
        slug: "plan-new-home-construction",
        title: "How to Plan Your New Home Construction from Start to Finish",
        excerpt: "Building a custom home is exciting — and complex. Here's a step-by-step breakdown of the process so you know exactly what to expect before you break ground.",
        content: [
          { type: "p", text: "Building a custom home is one of the most rewarding things you can do — and one of the most complex. The process spans months, involves dozens of decisions, and requires coordination across multiple trades and inspections. The homeowners who come out of it happy are almost always the ones who understood the process before it started. Here's a clear-eyed walkthrough." },
          { type: "h2", text: "Phase 1: Design and Planning" },
          { type: "p", text: "Before anything gets built, you need a set of plans. Work with an architect or designer to develop construction drawings that reflect your layout, finishes, and specifications. These drawings become the foundation for accurate bids, permits, and construction. Don't rush this phase — changes are cheap on paper and expensive in the field." },
          { type: "h2", text: "Phase 2: Permitting" },
          { type: "p", text: "Once drawings are finalized, your contractor submits them to the local building department for permit approval. In the Dallas–Fort Worth area, this process typically takes 3–8 weeks depending on the municipality and project complexity. Your contractor should handle this entirely — permitting is not a DIY activity." },
          { type: "h2", text: "Phase 3: Site Prep and Foundation" },
          { type: "p", text: "With permits in hand, work begins. The site is cleared, graded, and prepared. Forms are set and concrete is poured for the foundation — slab-on-grade is most common in North Texas. The foundation must cure and pass inspection before framing begins." },
          { type: "h2", text: "Phase 4: Framing, Mechanical Rough-Ins, and Inspections" },
          { type: "ul", items: [
            "Framing — the structural skeleton of the home goes up: walls, floor systems, roof trusses.",
            "Rough-in plumbing — drain lines, supply lines, and gas piping installed in walls and floors.",
            "Rough-in electrical — panel location, wiring runs, box placement.",
            "HVAC rough-in — ductwork, equipment pads, refrigerant lines.",
            "Inspections — each trade receives its own rough-in inspection before walls are closed.",
          ]},
          { type: "h2", text: "Phase 5: Insulation, Drywall, and Finishes" },
          { type: "p", text: "Once rough-ins pass inspection, insulation is installed and drywall goes up. From here, the project transitions into finish work: flooring, cabinetry, countertops, tile, trim, paint, plumbing fixtures, electrical devices, and appliances. This phase involves the most decisions — your selections should be finalized before construction reaches this point." },
          { type: "h2", text: "Phase 6: Final Inspections and Move-In" },
          { type: "p", text: "A final inspection covers all systems and confirms the home meets code. Once approved, a Certificate of Occupancy is issued and you're cleared to move in. A good contractor will also walk you through the home, explain all systems, and address any punch list items before handing over the keys. Ready to start planning? Contact our team for a free consultation." },
        ],
      },
      {
        slug: "questions-to-ask-general-contractor",
        title: "Top Questions to Ask Before Hiring a General Contractor",
        excerpt: "Not all contractors are equal. Before signing any contract, make sure you're asking the right questions to protect your project, your home, and your money.",
        content: [
          { type: "p", text: "Hiring a general contractor is a significant decision. The right one will deliver your project on time, on budget, and with quality that holds up for decades. The wrong one can cost you far more than the original project price. Here are the questions every homeowner should ask before signing anything." },
          { type: "h2", text: "Are You Licensed and Insured?" },
          { type: "p", text: "This is non-negotiable. In Texas, general contractors must hold appropriate licensing for the type of work performed. Ask for their license number and verify it with the Texas Department of Licensing and Regulation. Ask for a certificate of insurance showing general liability and workers' compensation coverage — and make sure you're listed as an additional insured. If a contractor can't provide this documentation immediately, walk away." },
          { type: "h2", text: "Can You Provide References from Similar Projects?" },
          { type: "p", text: "Any contractor worth hiring has a track record. Ask for 3–5 references from projects similar in size and type to yours. Call them. Ask whether the project came in on budget, whether the timeline was accurate, how the contractor handled problems, and whether they'd hire them again. Online reviews are helpful, but direct conversations with past clients are more revealing." },
          { type: "h2", text: "Who Will Be On-Site Managing the Work?" },
          { type: "p", text: "The person who sells you the job is not always the person who runs it. Ask specifically who the on-site superintendent will be, how often they'll be present, and how you'll communicate with them. A dedicated superintendent — not a contractor who's juggling 20 jobs from their truck — makes an enormous difference in project quality and communication." },
          { type: "h2", text: "Key Contract Provisions to Review" },
          { type: "ul", items: [
            "Scope of work — every item that's included (and explicitly, what's not included).",
            "Payment schedule — tied to project milestones, not arbitrary dates.",
            "Change order process — how changes are documented, priced, and approved.",
            "Timeline — start date, substantial completion date, and what happens if they're late.",
            "Lien waiver language — protects you if the contractor doesn't pay subcontractors.",
            "Warranty — workmanship warranty terms clearly stated.",
          ]},
          { type: "h2", text: "What Does the Bid Include — and Exclude?" },
          { type: "p", text: "Low bids often omit items that are later presented as 'extras.' Ask every contractor bidding your project to itemize their exclusions explicitly. If one bid is significantly lower than others, it's almost always because something is missing. Apples-to-apples comparison requires the same scope from every bidder." },
          { type: "h2", text: "The Bottom Line" },
          { type: "p", text: "The best contractor isn't the cheapest — it's the one who communicates clearly, delivers what they promise, and stands behind their work. At Construct With Us, we answer every one of these questions upfront and in writing. Schedule your free consultation and experience the difference." },
        ],
      },
      {
        slug: "home-addition-vs-moving",
        title: "Home Addition vs. Moving: Which Makes More Financial Sense?",
        excerpt: "Your family needs more space. But should you add onto your current home or sell and move? The answer depends on more than just square footage.",
        content: [
          { type: "p", text: "You've outgrown your home. Maybe the family is growing, you need a home office, or the in-laws are moving in. The question every homeowner eventually asks: do we add on, or do we sell and find something bigger? It's not a simple calculation — and the right answer depends on factors that go beyond square footage." },
          { type: "h2", text: "The Real Cost of Moving" },
          { type: "p", text: "Moving feels like a clean solution, but the true cost is often underestimated. Real estate commissions on your sale (typically 5–6%), closing costs on your purchase (2–3%), moving expenses, and the cost of upgrades to a new home all add up fast. In a competitive market, you may also pay a premium for a larger home. When you factor in everything, moving often costs $50,000–$150,000 or more beyond what the house itself costs." },
          { type: "h2", text: "The Case for Adding On" },
          { type: "p", text: "A well-designed home addition lets you get the space you need without losing the neighborhood, school district, and community you've invested in. And unlike moving costs — which are pure expense — a quality addition adds real value to your home. Master suite additions typically return 50–65% of their cost at resale. In strong markets like Dallas–Fort Worth, that figure is often higher." },
          { type: "h2", text: "When Moving Makes More Sense" },
          { type: "ul", items: [
            "Your current lot has no room to expand and you need significant square footage.",
            "Your home has fundamental issues (location, layout, lot) that no addition can fix.",
            "The addition cost would push your home's value significantly above the neighborhood ceiling.",
            "You're ready for a different neighborhood or school district regardless of space.",
          ]},
          { type: "h2", text: "When Adding On Makes More Sense" },
          { type: "ul", items: [
            "You love your neighborhood and don't want to lose your location.",
            "The addition cost is competitive with the net cost of moving.",
            "Your current home's layout can accommodate the addition seamlessly.",
            "You have equity you can tap via a home equity loan or cash-out refinance.",
          ]},
          { type: "h2", text: "Getting the Numbers Right" },
          { type: "p", text: "Before making any decision, get a free estimate on the addition you're considering. That number — compared honestly against the cost of moving — will tell you most of what you need to know. Our team will walk your property, discuss your vision, and give you a realistic figure to work with. No pressure, no obligation — just honest information." },
        ],
      },
      {
        slug: "kitchen-remodel-costs-what-to-expect",
        title: "Kitchen Remodel Costs: What to Expect in 2024",
        excerpt: "Kitchen remodels are one of the highest-ROI home improvements — but costs vary widely. Here's what drives the price and how to budget smart.",
        content: [
          { type: "p", text: "A kitchen remodel is consistently one of the highest-return investments a homeowner can make — both in daily quality of life and at resale. But the range of costs is enormous, and knowing what drives the price is the key to budgeting smart and avoiding sticker shock." },
          { type: "h2", text: "The Three Tiers of Kitchen Remodels" },
          { type: "p", text: "Cosmetic refresh ($10,000–$25,000): New cabinet doors and hardware, updated countertops, new appliances, fresh paint, and new flooring. No layout changes, no moving plumbing or electrical. Great for kitchens with good bones that just need freshening." },
          { type: "p", text: "Mid-range remodel ($25,000–$60,000): Semi-custom cabinetry, stone countertops, tile backsplash, new appliances, updated lighting, and minor layout modifications. May include moving a non-load-bearing wall or relocating a fixture or two." },
          { type: "p", text: "Full gut and remodel ($60,000–$150,000+): Complete demolition down to studs. Custom cabinetry, high-end appliances, structural modifications, expanded footprint, and premium finishes throughout. Common in luxury homes and high-equity renovations." },
          { type: "h2", text: "What Drives Kitchen Remodel Costs?" },
          { type: "ul", items: [
            "Cabinetry — the single largest line item, typically 30–40% of the total budget.",
            "Countertops — quartzite, marble, and premium quartz can run $100–$200+ per square foot installed.",
            "Appliances — a full suite of professional-grade appliances can add $15,000–$30,000 alone.",
            "Layout changes — moving plumbing, gas, or electrical requires permits and significantly increases cost.",
            "Labor — Dallas-area labor rates have risen sharply; budget accordingly.",
          ]},
          { type: "h2", text: "How to Stretch Your Budget" },
          { type: "p", text: "Keep the layout — relocating the sink, range, or refrigerator requires moving plumbing and electrical, which is expensive. Use that money on better finishes instead. Buy appliances as a package — manufacturers offer rebates when you purchase a matched suite. And don't cut corners on installation — poor tile work or cabinet installation will cost more to fix than it would have to do right the first time." },
          { type: "h2", text: "Let's Talk About Your Kitchen" },
          { type: "p", text: "Whether you're planning a refresh or a full transformation, the first step is a conversation. We'll meet with you in your home, assess the scope, and give you a detailed estimate broken down by trade so you know exactly what you're getting. Contact us today to schedule your free consultation." },
        ],
      },
      {
        slug: "commercial-construction-process",
        title: "Understanding the Commercial Construction Process",
        excerpt: "Commercial projects involve more stakeholders, stricter codes, and tighter timelines than residential work. Here's what to expect as a business owner.",
        content: [
          { type: "p", text: "Whether you're opening a first location, expanding, or building from the ground up, commercial construction is a different animal than residential work. More stakeholders, stricter codes, harder deadlines — and usually, a business that needs to open on a specific date. Here's what the process looks like and how to set your project up for success." },
          { type: "h2", text: "Pre-Construction: The Phase That Determines Everything" },
          { type: "p", text: "The decisions made before a single nail is driven determine whether a commercial project runs smoothly or falls apart. Scope definition, design development, contractor selection, and permit submission all happen in pre-construction. This phase should also include a detailed schedule with milestones and a contingency budget (typically 10–15% of the total) for unforeseen conditions." },
          { type: "h2", text: "Commercial vs. Residential Code Requirements" },
          { type: "ul", items: [
            "ADA compliance — commercial spaces must meet Americans with Disabilities Act requirements for accessibility, restrooms, parking, and more.",
            "Occupancy classifications — the type of business determines fire suppression, egress, ventilation, and structural requirements.",
            "Energy codes — commercial buildings are subject to ASHRAE energy standards that go beyond residential requirements.",
            "Fire suppression — most commercial occupancies require sprinkler systems designed by a licensed fire protection engineer.",
          ]},
          { type: "h2", text: "Managing Tenant Improvements" },
          { type: "p", text: "If you're leasing a space and building it out, your lease will specify what the landlord provides (the 'shell' condition) and what's your responsibility (the tenant improvement, or TI). Negotiate a TI allowance upfront and understand exactly what the shell includes before your contractor bids the project. Surprises in the walls — asbestos, code violations, undersized electrical — are common in older commercial buildings." },
          { type: "h2", text: "Timeline Expectations by Project Type" },
          { type: "p", text: "A simple office tenant improvement in an existing space: 6–12 weeks. A restaurant build-out in shell space: 12–20 weeks. A ground-up commercial building: 12–24 months depending on size and complexity. These timelines assume permits are obtained before construction starts — factoring in permitting can add 4–12 weeks on the front end." },
          { type: "h2", text: "Choosing the Right Contractor" },
          { type: "p", text: "Commercial construction requires a contractor with commercial experience — not just residential contractors who 'do commercial too.' Ask for commercial references, verify their experience with your occupancy type, and confirm they carry commercial-grade insurance and bonding. Construct With Us has delivered commercial projects across the Dallas–Fort Worth area for over a decade. Let's talk about yours." },
        ],
      },
      {
        slug: "foundation-issues-warning-signs",
        title: "How to Spot Foundation Issues Before They Become Costly Repairs",
        excerpt: "In North Texas, foundation problems are common — but catching them early makes all the difference. Learn the warning signs every homeowner should know.",
        content: [
          { type: "p", text: "If you live in the Dallas–Fort Worth area, foundation issues are not a question of if — they're a question of when. North Texas expansive clay soils shrink and swell dramatically with moisture changes, and that movement puts enormous stress on residential foundations. The good news: foundation problems caught early are far cheaper and simpler to address than ones that have been ignored for years." },
          { type: "h2", text: "Why North Texas Foundations Fail" },
          { type: "p", text: "The heavy clay soils in the DFW area absorb water and expand, then dry out and contract — sometimes by several inches — with seasonal changes and drought. This constant movement causes slab foundations to heave, settle unevenly, and crack. Poor drainage, tree roots drawing moisture from the soil, and plumbing leaks all make the problem worse." },
          { type: "h2", text: "Warning Signs to Watch For" },
          { type: "ul", items: [
            "Doors and windows that stick, bind, or won't close properly — especially if this developed gradually.",
            "Diagonal cracks running from the corners of door and window frames.",
            "Cracks in brick veneer, particularly stair-step cracks along mortar joints.",
            "Visible gaps between the wall and ceiling, or between the wall and floor.",
            "Uneven or sloping floors — place a marble on the floor and watch what happens.",
            "Cracks in the slab itself, especially those wider than 1/8 inch or that show vertical displacement.",
          ]},
          { type: "h2", text: "The Difference Between Cosmetic and Structural Cracks" },
          { type: "p", text: "Not all cracks are equal. Hairline cracks in drywall at corners are usually just settlement and shrinkage — cosmetic. Cracks that are wide, growing, run diagonally, or are accompanied by door and window problems are a different story. When in doubt, have a structural assessment performed. A professional can tell you quickly whether you have a cosmetic issue or a structural one." },
          { type: "h2", text: "Foundation Repair Options" },
          { type: "p", text: "The most common repair method in North Texas is pressed piering — steel piers driven through the unstable soil to reach stable load-bearing strata below, then used to lift and level the slab. A typical residential pier installation runs $1,500–$3,000 per pier, with most homes requiring 8–20 piers depending on the extent of movement. Addressing drainage and moisture issues alongside the piering work is critical to a long-lasting repair." },
          { type: "h2", text: "When to Call a Professional" },
          { type: "p", text: "If you're seeing multiple warning signs — especially if they've appeared or worsened recently — schedule a professional assessment before the problem gets worse or you list the home for sale. Undisclosed foundation issues are a leading cause of real estate disputes in Texas. Our team provides honest assessments and straightforward repair options. Contact us to schedule yours." },
        ],
      },
    ],
  },

  // ─── Services Section (homepage) ────────────────────────────────────────
  servicesSection: {
    intro: "From planning to final inspection, we deliver complete construction services built to code, on schedule, and crafted to last.",
    footerTagline: "We handle a full range of residential and commercial construction — tailored to your project, your timeline, and your budget.",
  },

  // ─── Service Area Detail Pages ────────────────────────────────────────
  serviceAreaPage: {
    heroSub: "Top-rated construction and remodeling services. Local team, quality results, free estimates.",
    bodyIntro: "has been proudly serving homeowners and businesses with full-service construction — new builds, additions, remodels, and repairs. Our team delivers quality craftsmanship tailored to each client's vision.",
    bodySecondary: "Whether you're planning a new home, a kitchen remodel, or a commercial build-out, our local crew is ready to help. We offer free, no-obligation estimates and stand behind every project we complete.",
  },

  social: {
    google:    "#",   // paste your Google Business Profile URL
    instagram: "#",   // paste your Instagram profile URL
    facebook:  "#",   // paste your Facebook page URL — leave "" to hide
  },

  hours: [
    { day: "Mon", time: "7:00AM – 6:00PM" },
    { day: "Tue", time: "7:00AM – 6:00PM" },
    { day: "Wed", time: "7:00AM – 6:00PM" },
    { day: "Thu", time: "7:00AM – 6:00PM" },
    { day: "Fri", time: "7:00AM – 6:00PM" },
    { day: "Sat", time: "8:00AM – 4:00PM" },
    { day: "Sun", time: "Closed" },
  ],

  // ─── FAQ + Service Areas section background ──
  // Photo URL shown behind the floating white wave section.
  // Swap for any image URL. Set "" to use the solid brand dark color instead (recommended).
  faqAreasBgImage: "",

  // ─── Google My Maps embed ────────────────────
  // 1. Go to Google My Maps → Share → Embed on my site
  // 2. Copy the src="..." URL from the <iframe> tag and paste it below
  // Leave as "" to hide the map and show a placeholder instead
  mapEmbedUrl: "",

  // ─── GoHighLevel Popup Form ───────────────────
  // Paste your GHL form PAGE URL (not embed code) here.
  // When set, the quote popup shows a GHL iframe instead of the native form.
  // Leave as "" to use the built-in native form.
  ghlPopupFormUrl: "",

  // ─── GoHighLevel Inline Embed (hero + contact page) ──
  // Paste your GHL embed code inside: src/components/QuoteFormEmbed.jsx
  ghlFormEmbed: "",

  // ─── Lead intake endpoint (serverless → GoHighLevel, NO premium fees) ──────
  // The quote form POSTs here (same-origin). Handled by the Cloudflare Pages
  // function at frontend/functions/api/lead.js, which creates the contact in
  // GoHighLevel via the standard (free) API — no iframe, no premium webhook.
  //
  // Per-client setup (Pages host → Settings → Environment variables):
  //   GHL_API_KEY      = sub-account Private Integration Token (pit-…)
  //   GHL_LOCATION_ID  = sub-account location ID
  // Then in GHL, trigger "Claude — 01 Speed to Lead" on:
  //   Contact Tag → "form submission lead"   (the function applies this tag)
  //
  // Leave the default unless you host the lead function somewhere else.
  leadEndpoint: "/api/lead",
};
